import React from 'react';
import CampoBuscarEquipo from '../../UI/campos/CampoBuscarEquipo.js';
import CampoComboEquipoEditable from '../../UI/campos/CampoComboEquipoEditable.js';
import CampoEditableCheck from '../../UI/campos/CampoEditableCheck.js';
import CampoEditableMultilinea from '../../UI/campos/CampoEditableMultilinea.js';
import CampoEditableNumero from '../../UI/campos/CampoEditableNumero.js';
import CampoComboTitulo from '../../UI/campos/CampoComboTitulo.js';
import CampoComboMovimiento from '../../UI/campos/CampoComboMovimiento.js';
import * as Campos from '../../constantes/Campos.js';
import * as TipoParticipacion from '../../constantes/TipoParticipacionTorneo.js';
import * as TipoEquipo from '../../constantes/TipoEquipo.js';
import styles from '../EditarItemLista.module.css';

const CamposTorneoParticipante = (props) => {
  const item = props.item;
  const editar = props.editar;
  const actualizar = props.actualizar;
  const torneo = props.contexto?.torneo;

  // Determinar tipo de equipo inicial según tipo de participación del torneo
  const tipoParticipacion = torneo?.tipoTorneo?.tipoParticipacion;
  let tipoEquipoInicial = null;
  if (
    tipoParticipacion === TipoParticipacion.CLUBES ||
    tipoParticipacion === TipoParticipacion.PAIS ||
    tipoParticipacion === TipoParticipacion.REGION
  ) {
    tipoEquipoInicial = { codigo: TipoEquipo.CLUB, descripcion: 'Club' };
  } else if (
    tipoParticipacion === TipoParticipacion.PAIS ||
    tipoParticipacion === TipoParticipacion.SELECCIONES
  ) {
    tipoEquipoInicial = { codigo: TipoEquipo.SELECCION, descripcion: 'Selección' };
  }

  const onCampoChange = (campo, valor) => {
    props.onCampoChange(campo, valor);
  };

  // Determinar si debe mostrar combo de equipos
  const mostrarComboEquipos =
    torneo &&
    torneo.pais &&
    torneo.categoria &&
    (tipoParticipacion === TipoParticipacion.CLUBES ||
      tipoParticipacion === TipoParticipacion.SELECCIONES ||
      tipoParticipacion === TipoParticipacion.PAIS);

  return (
    <React.Fragment>
      <tr>
        <td className={`${styles.titulo}`}>Equipo</td>
        <td className={`${styles.valor}`}>
          {mostrarComboEquipos ? (
            <CampoComboEquipoEditable
              nombre={Campos.TorneoParticipante.EQUIPO}
              valor={item?.equipo}
              pais={torneo.pais}
              categoria={torneo.categoria}
              tipoEquipo={tipoEquipoInicial}
              anioTorneo={torneo.anioInicio}
              onChange={onCampoChange}
            />
          ) : (
            <CampoBuscarEquipo
              nombre={Campos.TorneoParticipante.EQUIPO}
              valor={item?.equipo}
              editar={editar}
              width="80%"
              actualizar={actualizar}
              tipoInicial={tipoEquipoInicial}
              onEquipoElegido={onCampoChange}
            />
          )}
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Posición Final</td>
        <td className={`${styles.valor}`}>
          <CampoEditableNumero
            nombre={Campos.TorneoParticipante.POSICION_FINAL}
            valor={item?.posicionFinal}
            editar={editar}
            largo={3}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Partidos Jugados</td>
        <td className={`${styles.valor}`}>
          <CampoEditableNumero
            nombre={Campos.TorneoParticipante.PARTIDOS_JUGADOS}
            valor={item?.partidosJugados}
            editar={editar}
            largo={3}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Organizador</td>
        <td className={`${styles.valor}`}>
          <CampoEditableCheck
            nombre={Campos.TorneoParticipante.ORGANIZADOR}
            checked={item?.organizador || false}
            editar={editar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Título Obtenido</td>
        <td className={`${styles.valor}`}>
          <CampoComboTitulo
            estilo={styles.combo}
            nombre={Campos.TorneoParticipante.TITULO_OBTENIDO}
            valor={item?.tituloObtenido}
            editar={editar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Movimiento Divisional</td>
        <td className={`${styles.valor}`}>
          <CampoComboMovimiento
            estilo={styles.combo}
            nombre={Campos.TorneoParticipante.MOVIMIENTO_DIVISIONAL}
            valor={item?.movimientoDivisional}
            editar={editar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Observaciones</td>
        <td className={`${styles.valor}`}>
          <CampoEditableMultilinea
            filas="3"
            columnas="50"
            nombre={Campos.TorneoParticipante.OBSERVACIONES}
            valor={item?.observaciones || ''}
            editar={editar}
            actualizar={actualizar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
    </React.Fragment>
  );
};

export default CamposTorneoParticipante;
